import { css } from 'emotion';
import { space } from '@joykit';
import { getInterUIDynamicMetricCssObject } from 'fonts/Inter-UI/metrics';
import chroma from 'chroma-js';
import { animationTransition } from '@joykit/variables';

export namespace styles {
  export const container = css({
    width: 'auto',
    [`@media(min-width: 678px)`]: {
      width: 600
    }
  });

  export const themeItem = css({
    margin: space.stack.md
  });

  export const themeLink = (selected: boolean) =>
    css(
      {
        color: chroma('#333')
          .alpha(0.6)
          .css(),
        transition: animationTransition('color'),
        ':hover': {
          color: '#333'
        }
      },
      selected
        ? {
            color: '#333',
            border: 'none',
            ...getInterUIDynamicMetricCssObject(15),
            fontWeight: 'bold'
          }
        : undefined
    );
}
